import { getUserData } from '@/api/user';
import { getAuthenticationStatus } from '@/store/account/selector';
import { setAccount } from '@/store/account/slice';
import { useAppDispatch } from '@/store/hooks/useAppDispatch';
import { useAppSelector } from '@/store/hooks/useAppSelector';
import LocalStorageUtility from '@/utils/localStorage';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
// import { getUser } from 'src/api/user';
import { LocalStorageKeys } from 'src/enums/ELocalStorage';
import { USER_TYPES } from 'src/enums/EUser';

const useAuth = () => {
	const isAuthenticated = useAppSelector(getAuthenticationStatus);
	const dispatch = useAppDispatch();

	const authenticationStatus =
		LocalStorageUtility.getLocalData(LocalStorageKeys.AUTH_TOKEN) ?? isAuthenticated;

	const { data, error, isLoading, refetch } = useQuery({
		queryKey: ['account'],
		queryFn: () => getUserData({ from: USER_TYPES.CLIENT }),
		enabled: !!authenticationStatus,
		retry: false,
	});

	useEffect(() => {
		const initialize = async () => {
			// check token in query param
			const authToken = new URLSearchParams(window.location.search).get('AUTH_TOKEN');
			if (authToken) {
				LocalStorageUtility.setLocalData(LocalStorageKeys.AUTH_TOKEN, authToken);
				window.location.href = window.location.origin;
			}

			if (isAuthenticated) {
				return;
			}

			if (data?.success) {
				dispatch(
					//@ts-expect-error ignore for now
					setAccount({
						isAuthenticated: true,
						userAccount: data.data,
						authToken: data.token,
					}),
				);
			} else if (error) {
				// Handle unsuccessful authentication
				LocalStorageUtility.removeLocalData(LocalStorageKeys.AUTH_TOKEN);
				dispatch(
					setAccount({
						isAuthenticated: false,
						userAccount: {
							id: '',
							username: '',
							emailAddress: '',
							customerId: '',
							inboundDemo: false,
							outboundDemo: false,
							userType: 'Client',
						},
						authToken: undefined,
						user: null,
						agents: [],
						selectedAgentId: null,
						currentPage: '',
						activeConfigureTab: '',
						agentPreview: false,
						crmGroups: null,
					}),
				);
				window.location.href = '/login';
			}
		};

		initialize();
	}, [data, error, isAuthenticated, dispatch]);

	useEffect(() => {
		if (data?.success) {
			dispatch(
				//@ts-expect-error ignore for now
				setAccount({
					isAuthenticated: true,
					userAccount: data.data,
					authToken: data.token,
				}),
			);
		}
	}, [data, dispatch]);

	return {
		isAuthenticated: authenticationStatus,
		isLoading,
		refetch,
	};
};

export default useAuth;
